module.exports = __webpack_public_path__ + "img/coupon.00ac3e51.svg";